// GENERE par pnpm ouvertures:generer. Ne pas modifier a la main.
export const PORTEES_MODELE = {
  "conversations": {
    "canal": "org-wide",
    "direct": "org-wide"
  },
  "messages": {
    "conversation": "org-wide"
  },
  "products": {
    "article": "org-wide",
    "protocole": "org-wide"
  },
  "policies": {
    "posologie": "org-wide",
    "calcul": "org-wide"
  },
  "compositions": {
    "ligne": "org-wide"
  },
  "careRecords": {
    "consultation": "org-wide",
    "soin": "org-wide"
  },
  "inspections": {
    "examen": "org-wide",
    "complementaire": "org-wide"
  },
  "measurements": {
    "constante": "org-wide"
  },
  "todos": {
    "dossier": "org-wide",
    "tache": "org-wide"
  },
  "assets": {
    "animal": "org-wide"
  },
  "contacts": {
    "person": "org-wide",
    "organization": "org-wide"
  },
  "templates": {
    "careRecords": "org-wide"
  },
  "contents": {
    "croquis": "org-wide",
    "demo-town": "org-wide"
  },
  "projects": {
    "projet": "org-wide"
  },
  "tasks": {
    "tache": "org-wide"
  },
  "timesheets": {
    "journal": "org-wide"
  }
} as const;
export const PORTEES_PAR_APP = {
  "canaux": {
    "conversations": {
      "canal": "org-wide",
      "direct": "org-wide"
    },
    "messages": {
      "conversation": "org-wide"
    }
  },
  "catalogue": {
    "products": {
      "article": "org-wide",
      "protocole": "org-wide"
    },
    "policies": {
      "posologie": "org-wide",
      "calcul": "org-wide"
    },
    "compositions": {
      "ligne": "org-wide"
    }
  },
  "cockpit": {},
  "consultations": {
    "careRecords": {
      "consultation": "org-wide",
      "soin": "org-wide"
    },
    "inspections": {
      "examen": "org-wide",
      "complementaire": "org-wide"
    },
    "measurements": {
      "constante": "org-wide"
    },
    "todos": {
      "dossier": "org-wide"
    },
    "assets": {
      "animal": "org-wide"
    },
    "compositions": {
      "ligne": "org-wide"
    },
    "contacts": {
      "person": "org-wide"
    },
    "policies": {
      "calcul": "org-wide",
      "posologie": "org-wide"
    },
    "products": {
      "article": "org-wide",
      "protocole": "org-wide"
    },
    "templates": {
      "careRecords": "org-wide"
    }
  },
  "contact": {
    "contacts": {
      "person": "org-wide",
      "organization": "org-wide"
    }
  },
  "croquis": {
    "contents": {
      "croquis": "org-wide"
    }
  },
  "demo-town": {
    "contacts": {
      "organization": "org-wide",
      "person": "org-wide"
    },
    "projects": {
      "projet": "org-wide"
    },
    "tasks": {
      "tache": "org-wide"
    },
    "contents": {
      "demo-town": "org-wide"
    }
  },
  "flux": {},
  "patients": {
    "assets": {
      "animal": "org-wide"
    },
    "contacts": {
      "person": "org-wide"
    },
    "careRecords": {
      "consultation": "org-wide",
      "soin": "org-wide"
    },
    "inspections": {
      "examen": "org-wide"
    },
    "measurements": {
      "constante": "org-wide"
    },
    "products": {
      "article": "org-wide"
    },
    "todos": {
      "dossier": "org-wide"
    }
  },
  "projets": {
    "projects": {
      "projet": "org-wide"
    },
    "tasks": {
      "tache": "org-wide"
    },
    "contacts": {
      "organization": "org-wide"
    }
  },
  "smart-notes": {},
  "taches": {
    "todos": {
      "tache": "org-wide"
    }
  },
  "timesheet": {
    "timesheets": {
      "journal": "org-wide"
    },
    "projects": {
      "projet": "org-wide"
    },
    "tasks": {
      "tache": "org-wide"
    },
    "contacts": {
      "organization": "org-wide"
    }
  }
} as const;
